module.exports = __webpack_public_path__ + "0288066087fa1333b5653faec437e7ce.png";